<template>
  <v-container grid-list-xl class="pa-5">
    <v-alert
      v-if="is_premium"
      dense text
      class="body-2 mb-5"
      type="info"
    >
      Berikut ini merupakan data perangkat atau device yang digunakan pada
      instansi Anda.
    </v-alert>
    <m-card-list
      two-line
      title="Perangkat Instansi"
      label-cari="Cari Perangkat Instansi"
      search
      :items="items"
      :headers="headers"
      refresh
      @refresh="load"
      :page="page"
      footer
      @search="search"
      @change:page="
            pg => {
              cp = pg;
              load();
            }
          "
      @add="add"
    >
      <template v-slot:items="{ props, item }">
        <tr v-if="$vuetify.breakpoint.smAndUp">
          <td>{{ pVal(item, "nama") }}</td>
          <td>{{ pVal(item, "vendor") }}</td>
          <td v-if="item.is_activated == 1">
            <v-chip small outlined color="green">AKTIF</v-chip>
          </td>
          <td v-else>
            <v-chip small outlined color="red">TIDAK AKTIF</v-chip>
          </td>
          <td>
            <m-menu
              left
              style="float:right"
              :items="more_menu"
              :object="item"
            />
          </td>
        </tr>
        <tr v-else>
          <td class="v-data-table__mobile-row">
            <div class="v-data-table__mobile-row__header mr-2">Lokasi</div>
            <div class="v-data-table__mobile-row__cell">
              {{ pVal(item, "nama") }}
            </div>
          </td>
          <td class="v-data-table__mobile-row">
            <div class="v-data-table__mobile-row__header mr-2">
              Vendor
            </div>
            <div class="v-data-table__mobile-row__cell">
              {{ pVal(item, "vendor") }}
            </div>
          </td>
          <td class="v-data-table__mobile-row">
            <div class="v-data-table__mobile-row__header mr-2">
              Status
            </div>
            <div class="v-data-table__mobile-row__cell">
              <v-chip small
                      outlined
                      :color="item.is_activated ? 'success' : 'error'"
              >{{ item.is_activated ? "Aktif" : "Tidak Aktif" }}</v-chip
              >
            </div>
          </td>
          <td class="v-data-table__mobile-row">
            <div class="v-data-table__mobile-row__header mr-2">
              Aksi
            </div>
            <div class="v-data-table__mobile-row__cell">
              <m-menu
                left
                style="float:right"
                :items="more_menu"
                :object="item"
              />
            </div>
          </td>
        </tr>
      </template>
    </m-card-list>
    <ChangeDlg ref="dlg" @reload="load" />
  </v-container>
</template>

<script>
import { isCan } from "@/tools";
import ChangeDlg from "../components/Form.vue";
import BlockCard from "@/components/BlockCard";

export default {
  components: {
    ChangeDlg,
    BlockCard
  },
  data() {
    return {
      items: [],
      page: null,
      kode_organisasi: null,
      cp: 1,
      headers: [
        { text: "Letak Presensi", align: "left", value: "nama" },
        { text: "Vendor", align: "left", value: "vendor" },
        { text: "Status", align: "left", value: "is_activated" },
        { text: "", align: "left", sortable: false }
      ],
      more_menu: [
        // eslint-disable-next-line
        {
          title: "Ubah",
          click: (i, o) => this.edit(o),
          check: () => isCan("perangkat.update")
        },
        {
          title: "Hapus",
          click: (i, o) => this.hapus(o),
          check: () => isCan("perangkat.destroy")
        },
        {
          title: "Aktifkan Perangkat",
          click: this.setAktif,
          check: (i, o) => o.is_activated == 0 && isCan("perangkat.set-status")
        },
        {
          title: "Non Aktifkan Perangkat",
          click: this.setNonAktif,
          check: (i, o) => o.is_activated == 1 && isCan("perangkat.set-status")
        },
        {
          title: "Proses Ulang Data",
          click: this.resetCounter,
          check: (i, o) => o.is_activated == 1 && isCan("perangkat.set-status")
        }
      ]
    };
  },
  computed: {},
  activated() {
    this.load();
  },
  methods: {
    load() {
      this.$store
        .dispatch("device/get", {
          organisasi_id: this.organisasi_id || this.tenant_id,
          params: { page: this.cp }
        })
        .then(res => {
          this.page = res.data;
          this.items = res.data.data;
        })
        .catch(e => e);
    },
    add() {
      this.$refs.dlg.open().then(() => {
        this.load();
      });
    },
    edit(item) {
      this.$refs.dlg.open(item)
    },
    search(textSearch) {
      this.$store
        .dispatch("device/get", {
          organisasi_id: this.organisasi_id || this.tenant_id,
          params: { page: this.cp, search: textSearch }
        })
        .then(res => {
          this.page = res.data;
          this.items = res.data.data;
        })
        .catch(e => e);
    },
    hapus(item) {
      this.$confirmDanger(
        `<div class="px-5 mx-1 mt-2 py-2 mb-4 pa-1 row red lighten-5 rounded red--text">

            <i class="v-icon v-alert__icon mdi mdi-information red--text"></i>

            <div class="col py-0 body-2">
            Jika Anda Menghapus Data Perangkat ini. Maka Perangkat ini Tidak Dapat Digunakan
          </div>
        </div>

        Apakah Anda Yakin Akan Menghapus Data Perangkat Presensi ini ??<br>
        <div class="mt-2 title grow text-center">
          ${item.nama}<br>
        </div>

      `
      )
        .then(() =>
          this.$store.dispatch("device/drop", {
            kode_organisasi: this.organisasi_id || this.tenant_id,
            perangkat_id: item.perangkat_id
          })
        )
        .then(() => {
          this.$info("Data berhasil dihapus");
        })
        .then(() => this.load())
        .catch(e => e);
    },
    resetCounter(item, obj) {
      this.$confirmDanger(
        `Apakah Anda yakin akan memproses ulang catatan penggunaan perangkat ini ?<br>
        <div class="mt-2 title grow text-center">
          ${obj.nama}<br>
        </div>
      `
      )
        .then(() =>
          this.$store.dispatch("device/resetCounter", {
            kode_organisasi: this.organisasi_id || this.tenant_id,
            perangkat_id: obj.perangkat_id
          })
        )
        .then(() => {
          this.$info("Proses Ulang Perangkat Berhasil");
        })
        .then(() => this.load())
        .catch(e => e);
    },
    setAktif(item, obj) {
      this.$confirmDanger(
        `Apakah anda yakin akan mengaktifkan perangkat berikut?<br>
        <div class='mt-2 title font-weight-bold text-center red--text text--darken-2'>
          ${obj.android_id}
        </div>
        `
      )
        .then(() =>
          this.$store.dispatch("device/ubahStatus", {
            obj: obj,
            is_aktif: true
          })
        )
        .then(() => this.load())
        .catch(e => e);
    },
    setNonAktif(item, obj) {
      this.$confirmDanger(
        `Apakah anda yakin akan menonaktifkan perangkat berikut?<br>
        <div class='mt-2 title font-weight-bold text-center red--text text--darken-2'>
          ${obj.nama}
        </div>
        `
      )
        .then(() =>
          this.$store.dispatch("device/ubahStatus", {
            obj: obj,
            is_aktif: false
          })
        )
        .then(() => this.load())
        .catch(e => e);
    },
    drop(item, obj) {
      this.$confirmDanger(
        `Apakah anda yakin akan menghapus device berikut?<br>
        <div class='mt-2 title font-weight-bold text-center red--text text--darken-2'>
          ${obj.nama}
        </div>
        `
      )
        .then(() =>
          this.$store.dispatch("device/drop", {
            kode_organisasi: this.organisasi_id || this.tenant_id,
            perangkat_id: obj.perangkat_id
          })
        )
        .then(() => this.load())
        .catch(e => e);
    }
  }
};
</script>
